import * as React from "react";

import styles from "./ProjectDocsMobileSearch.module.css";

export interface ProjectDocsMobileSearchProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string
}

export const ProjectDocsMobileSearch: React.FC<ProjectDocsMobileSearchProps> = ({value, onChange, placeholder='Поиск документа'}) => (
    <div className={styles.search}>
        <i className="fa-solid fa-magnifying-glass" aria-hidden="true"/>
        <input
            className={styles.input}
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}/>
    </div>
);
